export const jk = ["Laki-laki", "Perempuan"];

export const suku = [
   "Dayak",
   "Jawa",
   "Chinese/Tionghoa",
   "Melayu",
   "Padang",
   "Batak",
   "Bugis",
   "Sunda",
   "Madura",
   "Betawi",
];

export const pendididkan = [
   "Tidak Sekolah",
   "SD",
   "SMP",
   "SMA",
   "DIII",
   "DIV",
   "S1",
   "S2",
   "S3",
   "SLB",
   "Non Formal",
];

export const aktivitas = [
   "Pengurus RT/RW/Desa/Kelurahan",
   "Pengurus Partai",
   "Pengurus Ormas",
   "Pengurus LSM",
   "Warga biasa",
];

export const profesi = [
   "Bidan",
   "Biarawan/Biarawati",
   "Guru",
   "Apoteker",
   "Akuntan",
   "Auditor",
   "Konsultan",
   "Petani",
   "Pekerja Media",
   "Juru Masak",
   "Dosen",
   "Dokter",
];

export const keterampilan = [
   "Musik",
   "Memasak",
   "Menyanyi",
   "Pembaawa Acara",
   "Elektronik",
   "Komputer",
   "Marketing",
   "Menulis",
   "Bertukang",
   "Menari",
];

export const jurusan = [
   "Kedokteran",
   "Kedokteran Gigi",
   "Kedokteran Hewan",
   "Kesehatan Masyarakat",
   "Kesehatan Lingkungan",
   "Ilmu Gizi",
   "Keselamatan dan Kesehatan Kerja",
   "Ilmu Keperawatan",
   "Farmasi",
   "Nutrisi dan Teknologi Pangan",
   "Kebidanan",
   "Fisioterapi",
   "Ilmu Keolahragaan",
   "Teknik Rasiodiagnostik dan Radioterapi",
   "Manajemen Pelayanan Rumah Sakit",
];

export const paroki = [
   "PAROKI KATEDRAL KRISTUS RAJA SINTANG",
   "PAROKI MARIA RATU SEMESTA ALAM",
   "PAROKI SANTO PETRUS",
   "PAROKI SANTO MARTINUS",
   "PAROKI MARIA RATU ROSARI",
   "PAROKI MARIA IMMACULATA",
   "PAROKI SANTO MIKAEL",
   "PAROKI SANTO YUSUF",
   "PAROKI SANTO YOSEF",
   "PAROKI SANTO PAULUS",
   "PAROKI SALIB SUCI",
   "PAROKI SANTA THERESIA KECIL",
   "PAROKI KELUARGA KUDUS",
   "PAROKI MARIA RATU DAMAI SEMESTA",
   "PAROKI SANTO PETRUS DAN ANDREAS",
];

export const keuskupan = ["KEUSKUPAN SINTANG"];
export const kecamatan = [
   "Sintang",
   "Ambalau",
   "Binjai Hulu",
   "Dedai",
   "Kayan Hilir",
   "Kayan Hulu",
   "Kelam Permai",
   "Ketungau Hilir",
   "Ketungau Hulu",
   "Ketungau Tengah",
   "Sei Tebelian (Sungai Tebelian)",
   "Sepauk",
   "Serawai",
   "Tempunak",
];
export const kabupaten = [
   "Kabupaten Sintang",
   "Kabupaten Bengkayang",
   "Kabupaten Kapuas Hulu",
   "Kabupaten Kayong Utara",
   "Kabupaten Ketapang",
   "Kabupaten Kubu Raya",
   "Kabupaten Landak",
   "Kabupaten Melawi",
   "Kabupaten Mempawah",
   "Kabupaten Sambas",
   "Kabupaten Sanggau",
   "Kabupaten Sekadau",
   "Kota Pontianak",
   "Kota Singkawang",
];
export const desa = [
   "Akcaya",
   "Alai",
   "Anggah Jaya",
   "Baning Kota",
   "Batu Lalau",
   "Jerora Satu",
   "Kapuas Kanan Hilir",
   "Kapuas Kanan Hulu",
   "Kapuas Kiri Hilir",
   "Kapuas Kiri Hulu",
   "Kebiau Baru",
   "Kedabang",
   "Ladang",
   "Lalang Baru",
   "Mail Jampong",
   "Mekar Jaya",
   "Mengkurai",
   "Menyumbung Tengah",
   "Merti Guna",
   "Mungguk Bantok",
   "Rawa Mambok",
   "Sengkuang",
   "Sungai Ana",
   "Tanjung Kelansam",
   "Tanjung Puri",
   "Tebing Raya",
   "Teluk Kelansam",
   "Tertung",
   "Ulak Jaya",
];

export const hubungan = ["Suami", "Istri", "Anak", "Menantu", "Mertua", "ART"];

export default {
   jk,
   suku,
   pendididkan,
   jurusan,
   profesi,
   aktivitas,
   paroki,
   keuskupan,
   kabupaten,
   kecamatan,
   desa,
   hubungan,
};
